import { useEffect, useState } from "react";
import { updateSystemSettings } from "../../services/adminPanel_service";
import { toast } from "react-toastify";

const SystemSettingsModal = ({
  show,
  initialData,
  onClose,
  dataReload
}) => {

  const [value, setValue] = useState("");

  useEffect(() => {
    if (initialData) {
      setValue(initialData.value);
    }
  }, [initialData]);

  if (!show) return null;

  const handleSave = async () => {

    try {

      const payload = {
        ...initialData,
        value: value
      };

      await updateSystemSettings(payload);

      toast.success("System setting updated successfully.");

      dataReload();

      onClose();

    }
    catch {
      toast.error("Unable to update system setting.");
    }

  };

  return (
    <>
      <div className="modal fade in" style={{ display: "block" }}>

        <div className="modal-dialog" style={{ width: "700px" }}>

          <div className="modal-content">

            {/* HEADER */}

            <div className="modal-header" style={{ padding: "0px 0px" }}>

              <button
                type="button"
                className="close"
                onClick={onClose}
              >
                &times;
              </button>

              <h4 className="modal-title" style={{ margin: 0 }}>
                Update System Settings
              </h4>

            </div>

            {/* BODY */}

            <div
              className="modal-body"
              style={{
                paddingBottom: "85px",
                paddingTop: "30px"
              }}
            >

              <div className="form-group">

                <label
                  className="col-sm-4"
                  style={{ paddingTop: "8px" }}
                >
                  {initialData.keyName} :
                </label>

                <div className="col-sm-8">

                  <textarea
                    rows="3"
                    className="form-control"
                    value={value}
                    onChange={(e) =>
                      setValue(e.target.value)
                    }
                    style={{
                        resize: "none",
                        width: "100%"
                    }}
                  />

                </div>

              </div>

            </div>

            {/* FOOTER */}

            <div className="modal-footer">

              <button
                className="btn btn-primary"
                onClick={handleSave}
              >
                Update
              </button>

              <button
                className="btn btn-default"
                onClick={onClose}
              >
                Cancel
              </button>

            </div>

          </div>

        </div>

      </div>

      {/* Backdrop intentionally removed */}
    </>
  );
};

export default SystemSettingsModal;